interface JudgmentButtonsProps {
  disabled: boolean;
  finalMode: boolean;
  onJudge: (isAnomaly: boolean) => void;
}

export function JudgmentButtons({ disabled, finalMode, onJudge }: JudgmentButtonsProps) {
  return (
    <div className="judgment-panel" aria-label="判定操作">
      <div className="judgment-help">
        {finalMode ? "最終メールを処理してください。" : "送信者・本文・日時・署名・宛先を確認してください。"}
      </div>
      <div className="judgment-buttons">
        <button type="button" className="judge-button judge-normal" disabled={disabled} onClick={() => onJudge(false)}>
          <span className="judge-key">A</span>
          異変なし
        </button>
        <button type="button" className="judge-button judge-anomaly" disabled={disabled} onClick={() => onJudge(true)}>
          <span className="judge-key">D</span>
          異変あり
        </button>
      </div>
    </div>
  );
}
